export default __webpack_public_path__ + "static/media/print-3-labels-second-position.ada6ef24.svg";